const mapSingleLabelGivenBy = (json: IClientTeamMembershipsLabelsGivenBy): IClientTeamMembershipsLabelsGivenByModel => {
	const { receiver_client_id, receiver_name, ...rest } = json

	return {
		...rest,
		receiverClientId: receiver_client_id,
		receiverName: receiver_name,
	}
}

export const ClientTeamMembershipsLabelsGivenBy = (
	json: Record<string, IClientTeamMembershipsLabelsGivenBy>,
): Record<string, IClientTeamMembershipsLabelsGivenByModel> =>
	Object.fromEntries(Object.entries(json).map(([key, value]) => [key, mapSingleLabelGivenBy(value)]))

const mapSingleLabelGivenTo = (json: IClientTeamMembershipsLabelsGivenTo): IClientTeamMembershipsLabelsGivenToModel => {
	const { giver_client_id, giver_name, ...rest } = json

	return {
		...rest,
		giverClientId: giver_client_id,
		giverName: giver_name,
	}
}

export const ClientTeamMembershipsLabelsGivenTo = (
	json: Record<string, IClientTeamMembershipsLabelsGivenTo>,
): Record<string, IClientTeamMembershipsLabelsGivenToModel> =>
	Object.fromEntries(Object.entries(json).map(([key, value]) => [key, mapSingleLabelGivenTo(value)]))

export const ClientTeamOwner = (json: IClientTeamOwner): IClientTeamOwnerModel => {
	const { email_verification_token, email_verified_at, password_reset_token, phone_number, is_active, ...rest } = json

	return {
		...rest,
		emailVerifiedAt: email_verified_at,
		emailVerificationToken: email_verification_token,
		passwordResetToken: password_reset_token,
		phoneNumber: phone_number,
		isActive: is_active,
	}
}

export const ClientTeamInvitations = (json: IClientTeamInvitations): IClientTeamInvitationsModel => {
	const { team_id, created_at, updated_at, ...rest } = json

	return {
		...rest,
		teamId: team_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ClientTeamClientProfile = (json: IClientTeamClientProfile): IClientTeamClientProfileModel => {
	const {
		client_id,
		first_name,
		last_name,
		onboarding_completed,
		birth_date,
		diet_expectation,
		weight_goal,
		can_receive_invitations,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		clientId: client_id,
		firstName: first_name,
		lastName: last_name,
		onboardingCompleted: onboarding_completed,
		birthDate: birth_date ? new Date(birth_date) : null,
		dietExpectation: diet_expectation,
		weightGoal: weight_goal,
		canReceiveInvitations: can_receive_invitations,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ClientTeamClient = (json: IClientTeamClient): IClientTeamClientModel => {
	const { is_active, ...rest } = json

	return {
		...rest,
		isActive: is_active,
	}
}

export const ClientTeamLabel = (json: IClientTeamLabel): IClientTeamLabelModel => {
	const { giver_name, giver_client_id, ...rest } = json

	return {
		...rest,
		giverName: giver_name,
		giverClientId: giver_client_id,
	}
}

export const ClientTeamMemberships = (json: IClientTeamMemberships): IClientTeamMembershipsModel => {
	const {
		team_id,
		client_id,
		client,
		client_profile,
		labels,
		labels_given_to_me,
		labels_given_by_me,
		is_active,
		invitations_enabled, // Czy członek może zapraszać do grupy
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		teamId: team_id,
		clientId: client_id,
		client: ClientTeamClient(client),
		clientProfile: ClientTeamClientProfile(client_profile),
		labels: labels?.map(l => ClientTeamLabel(l)) ?? [],
		labelsGivenToMe: ClientTeamMembershipsLabelsGivenTo(labels_given_to_me),
		labelsGivenByMe: ClientTeamMembershipsLabelsGivenBy(labels_given_by_me),
		isActive: is_active,
		invitationsEnabled: invitations_enabled, // Mapowanie pola możliwości zapraszania
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ClientTeam = (json: IClientTeam): IClientTeamModel => {
	const {
		client_id,
		invitation_code,
		membership_count,
		invitations_enabled,
		memberships,
		team_invitations,
		owner_profile,
		owner,
		owner_labels,
		owner_labels_given_to_me,
		owner_labels_given_by_me,
		...rest
	} = json

	return {
		...rest,
		clientId: client_id,
		invitationCode: invitation_code,
		membershipCount: membership_count,
		invitationsEnabled: invitations_enabled,
		memberships: memberships?.map(m => ClientTeamMemberships(m)) ?? [],
		teamInvitations: team_invitations?.map(t => ClientTeamInvitations(t)) ?? [],
		ownerProfile: ClientTeamClientProfile(owner_profile),
		owner: ClientTeamOwner(owner),
		ownerLabels: owner_labels?.map(l => ClientTeamLabel(l)) ?? [],
		ownerLabelsGivenToMe: ClientTeamMembershipsLabelsGivenTo(owner_labels_given_to_me ?? {}),
		ownerLabelsGivenByMe: ClientTeamMembershipsLabelsGivenBy(owner_labels_given_by_me ?? {}),
	}
}
